import React from "react";
import "./style.css";
import ChallanGeneratedGraph from "./Common/ChallanGeneratedGraph";
import ChallaRequestReceived from "./Common/ChallanRequestReceived";
import VehicleReports from "./Common/VehicleReports";
import GoodsRequested from "./Common/GoodsRequested";
import InvoiceGeneratedGraph from "./Common/InvoiceGeneratedGraph";
import OBTS from "./Common/OBTS";

function SilliguriDashboard() {
  return (
    <div className="row m-0">
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="graph-outline mb-3">
          <OBTS depo="60" />
        </div>
      </div>
      <div className="col col-12 col-md-12  col-lg-6">
        <div className="graph-outline mb-3">
          <InvoiceGeneratedGraph depo="60" />
        </div>
      </div>

      {/* Removed */}
      {/* <div className="col col-12 col-md-12 col-lg-6">
        <div className="graph-outline mb-3">
          <GoodsRequested depo="60" />
        </div>
      </div>
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="graph-outline mb-3" style={{ height: "400px" }}>
          <ChallaRequestReceived depo="4" />
        </div>
      </div>
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="graph-outline mb-3" style={{ height: "400px" }}>
          <VehicleReports />
        </div>
      </div> */}
    </div>
  );
}

export default SilliguriDashboard;
